module.exports = __webpack_public_path__ + "ab8b9b35d78373c37b82c970e2cb462d.svg";